import React, { FunctionComponent, useState, useEffect } from "react";
import {
  CloseIconThin,
  HelpDrawer,
  HelpDrawerToggle,
} from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../../helpers";
import { MedigapWaiverType } from "../utils/plans";

const PhasedOutPlans: FunctionComponent<{ waiverType: MedigapWaiverType }> = ({
  waiverType = MedigapWaiverType.NONE,
}) => {
  const t = useTranslate();
  const [open, setOpen] = useState(false);

  const waiverPrefix =
    waiverType === MedigapWaiverType.NONE ? "" : `.${waiverType.toLowerCase()}`;

  const clickHandler = (e: MouseEvent): void => {
    const target = e.target as HTMLElement;
    if (
      !target.closest(".mct-c-help-drawer") &&
      !target.matches(".help-drawer-toggle")
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("click", clickHandler);
    } else {
      document.removeEventListener("click", clickHandler);
    }
  }, [open]);

  return (
    <>
      <HelpDrawerToggle
        helpDrawerOpen={open}
        showDrawer={(): void => setOpen(true)}
        className="help-drawer-toggle"
        inline
      >
        {t(`medigap.phased_out_plans_help_drawer${waiverPrefix}.toggle`)}
      </HelpDrawerToggle>
      {open && (
        <div className="mct-c-help-drawer ds-u-text-align--left">
          <HelpDrawer
            heading={t(`medigap.phased_out_plans_help${waiverPrefix}.title`)}
            onCloseClick={(): void => setOpen(false)}
            closeButtonText={<CloseIconThin />}
            ariaLabel={t("close_help_drawer")}
          >
            <p>
              {t(`medigap.phased_out_plans_help${waiverPrefix}.paragraph_1`)}
            </p>
            <ul className="ds-u-margin-top--2 mct-disc-list">
              <li>{t("medigap.phased_out_plans_help.caveat_1")}</li>
              <li>{t("medigap.phased_out_plans_help.caveat_2")}</li>
            </ul>
            <p>
              {t(`medigap.phased_out_plans_help${waiverPrefix}.paragraph_2`)}
            </p>
          </HelpDrawer>
        </div>
      )}
    </>
  );
};

export default PhasedOutPlans;
